module.exports = __webpack_public_path__ + "img/WP2023-Dubai4.483eb68e.jpg";